import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {Field} from "../../../../../layouts";
import {TextBox} from "devextreme-react/text-box";
import {EmailRule, RequiredRule, StringLengthRule, Validator} from "devextreme-react/validator";
import {CUSTOMER_ADDRESS_MAX_LENGTH, CUSTOMER_NAME_MAX_LENGTH} from "../../../constants";
import Box, {Item} from "devextreme-react/box";
import {useZipCodeInformation} from "../../api/get-zip";

export function CustomerInformationControl() {
    const context = useCountertops();
    const zipInfo = useZipCodeInformation(context.customerZip)
    const [collapse, setCollapse] = useState<boolean>(true);

    useEffect(() => {
        if (!zipInfo.data) {
            return;
        }

        context.setCustomerState(zipInfo.data.state);
        context.setCustomerCity(zipInfo.data.city);
    }, [zipInfo.data])

    return (
        <>
            <p className={"box-header" + (collapse ? '' : ' box-header-collapsed')}>
                Customer Information
                <a onClick={() => {
                    setCollapse(!collapse);
                }}>
                    <i className={(collapse ? "dx-icon-spinup" : "dx-icon-spindown") + " dx-icon-custom-style"}
                       style={{float: "right", fontSize: "32px", lineHeight: "20px"}}></i>
                </a>
            </p>
            {collapse &&
                <>
                    <Box>
                        <Item ratio={30}>
                            <Field label={'Customer Name'}>
                                <TextBox inputAttr={{'data-testid': 'txt-customer-name'}}
                                         className='required'
                                         value={context.customerName}
                                         maxLength={CUSTOMER_NAME_MAX_LENGTH}
                                         onValueChanged={(e) => context.setCustomerName(e.value)}
                                >
                                    <Validator>
                                        <RequiredRule message={'Customer Name is required'}></RequiredRule>
                                        <StringLengthRule max={CUSTOMER_NAME_MAX_LENGTH}
                                            message={`Customer name is too long (max ${CUSTOMER_NAME_MAX_LENGTH} characters).`} />
                                    </Validator>
                                </TextBox>
                            </Field>
                            <Field label={'Address1'}>
                                <TextBox inputAttr={{'data-testid': 'txt-customer-address1'}}
                                         className='required'
                                         maxLength={CUSTOMER_ADDRESS_MAX_LENGTH}
                                         value={context.customerAddress1}
                                         onValueChanged={(e) => context.setCustomerAddress1(e.value)}
                                >
                                    <Validator>
                                        <RequiredRule message={'Customer Address1 is required'}></RequiredRule>
                                        <StringLengthRule max={CUSTOMER_ADDRESS_MAX_LENGTH}
                                            message={`Customer address line 1 is too long (max ${CUSTOMER_ADDRESS_MAX_LENGTH} characters).`} />
                                    </Validator>
                                </TextBox>
                            </Field>
                            <Field label={'Address2'}>
                                <TextBox inputAttr={{'data-testid': 'txt-customer-address2'}}
                                         maxLength={CUSTOMER_ADDRESS_MAX_LENGTH}
                                         value={context.customerAddress2}
                                         onValueChanged={(e) => context.setCustomerAddress2(e.value)}
                                >
                                    <Validator>
                                        <StringLengthRule max={CUSTOMER_ADDRESS_MAX_LENGTH}
                                            message={`Customer address line 2 is too long (max ${CUSTOMER_ADDRESS_MAX_LENGTH} characters).`} />
                                    </Validator>
                                </TextBox>
                            </Field>
                            <Field label={'Zip'}>
                                <TextBox inputAttr={{'data-testid': 'txt-customer-zip'}}
                                         className='required'
                                         value={context.customerZip}
                                         maxLength={5}
                                         mask="00000"
                                         maskChar={''}
                                         onValueChanged={(e) => context.setCustomerZip(e.value)}
                                >
                                    <Validator>
                                        <RequiredRule message={'Customer Zip is required'}></RequiredRule>
                                    </Validator>
                                </TextBox>
                            </Field>
                            <Field label={'City'}>
                                <TextBox inputAttr={{'data-testid': 'txt-customer-city'}}
                                         className='required'
                                         value={context.customerCity}
                                         disabled={zipInfo.isLoading}
                                         onValueChanged={(e) => context.setCustomerCity(e.value)}
                                >
                                    <Validator>
                                        <RequiredRule message={'Customer City is required'}></RequiredRule>
                                    </Validator>
                                </TextBox>
                            </Field>
                            <Field label={'State'}>
                                <TextBox inputAttr={{'data-testid': 'txt-customer-state'}}
                                         className='required'
                                         value={context.customerState}
                                         disabled={zipInfo.isLoading}
                                         onValueChanged={(e) => context.setCustomerState(e.value)}
                                >
                                    <Validator>
                                        <RequiredRule message={'Customer State is required'}></RequiredRule>
                                    </Validator>
                                </TextBox>
                            </Field>
                            <Field label={'Phone'}>
                                <TextBox inputAttr={{'data-testid': 'txt-customer-phone'}}
                                         className='required'
                                         value={context.customerPhone}
                                         mask="000-000-0000"
                                         onValueChanged={(e) => context.setCustomerPhone(e.value)}
                                >
                                    <Validator>
                                        <RequiredRule message={'Customer Phone is required'}></RequiredRule>
                                    </Validator>
                                </TextBox>
                            </Field>
                            <Field label={'Email'}>
                                <TextBox inputAttr={{'data-testid': 'txt-customer-email'}}
                                         className='required'
                                         value={context.customerEmail}
                                         onValueChanged={(e) => context.setCustomerEmail(e.value)}
                                >
                                    <Validator>
                                        <RequiredRule message={'Customer Email is required'}></RequiredRule>
                                        <EmailRule></EmailRule>
                                    </Validator>
                                </TextBox>
                            </Field>
                        </Item>
                        <Item ratio={70}></Item>
                    </Box>
                </>
            }
        </>
    );
}
